import * as React from "react"

import { cn } from "../../lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Same look, but as tall as `rows` instead of the standard minimum height (small notes in drawers and dialogs). */
  compact?: boolean
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, compact, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // font-form-input / generic-form-field / generic-form-textarea (design-system/forms.css) carry the shared look; the rest is the
          // same border, radius and focus ring as components/ui/input.tsx, plus the error state (aria-invalid)
          "font-form-input generic-form-field generic-form-textarea flex w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-secondary-foreground placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:border-ring aria-[invalid=true]:border-destructive disabled:cursor-not-allowed disabled:opacity-50",
          compact && "generic-form-textarea-compact",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea } 